import { render, staticRenderFns } from "./categoryBox.vue?vue&type=template&id=b0325766&scoped=true&"
import script from "./categoryBox.vue?vue&type=script&lang=js&"
export * from "./categoryBox.vue?vue&type=script&lang=js&"
import style0 from "./categoryBox.vue?vue&type=style&index=0&id=b0325766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0325766",
  null
  
)

export default component.exports